module.exports = __webpack_public_path__ + "static/shoe-layers-4-764dab03b4f7f6851c24f5d487049bf1.png";